import { useQuery, UseQueryOptions } from 'react-query';

import { useService } from '@core/inversify-react';

import { GetStatusByIdRepoType, IGetStatusByIdRepo } from '../repos';
import { IStatus } from '../interfaces';

export const useStatusById = (id?: string, options?: UseQueryOptions<IStatus, Error, IStatus, string[]>) => {
  const getStatusByIdRepo = useService<IGetStatusByIdRepo>(GetStatusByIdRepoType);

  return useQuery<IStatus, Error, IStatus, string[]>(
    ['status', id || ''],
    async ({ queryKey }) => {
      const [, id] = queryKey;
      const result = await getStatusByIdRepo.execute(id);

      if (result.status === 200) {
        return result.response;
      } else {
        throw new Error(result.response);
      }
    },
    options,
  );
};
